var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { styled } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
var openedMixin = function (theme, width) { return ({
    width: width,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    borderRight: 'none',
    background: theme.palette.common.black,
}); };
var closedMixin = function (theme) {
    var _a;
    return (_a = {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            borderRight: 'none',
            width: "72px"
        },
        _a[theme.breakpoints.up('sm')] = {
            width: "72px",
        },
        _a.background = theme.palette.common.black,
        _a);
};
var Drawer = function (_a) {
    var logo = _a.logo, onToggle = _a.onToggle, open = _a.open, menu = _a.menu, width = _a.width;
    var itemSelected = useRef('');
    var DrawerStyled = useMemo(function () {
        return styled(MuiDrawer, {
            shouldForwardProp: function (prop) { return prop !== 'open'; },
        })(function (_a) {
            var theme = _a.theme, open = _a.open;
            return (__assign(__assign({ width: width, flexShrink: 0, whiteSpace: 'nowrap', boxSizing: 'border-box' }, (open && __assign(__assign({}, openedMixin(theme, width)), { '& .MuiDrawer-paper': openedMixin(theme, width) }))), (!open && __assign(__assign({}, closedMixin(theme)), { '& .MuiDrawer-paper': closedMixin(theme) }))));
        });
    }, [width]);
    var drawer = (_jsxs("div", { children: [_jsx(DrawerHeader, { logo: logo, onToggle: onToggle, open: open }), _jsx(DrawerContent, { menu: menu, open: open, itemSelected: itemSelected })] }));
    return (_jsx(DrawerStyled, { variant: "permanent", open: open, children: drawer }));
};
export default Drawer;
